import NamedListPage from "@/features/org/components/NamedListPage";
import { groups } from "@/features/org/api/org.api";
import { FIELD_MAX } from "@/lib/fieldLimits";

export default function GroupsPage() {
  return (
    <NamedListPage
      api={groups}
      title="Groups"
      subtitle="Manage the org groups agents can belong to. These appear as suggestions on the user's Group field."
      noun="group"
      nameMax={FIELD_MAX.org.name}
      descMax={FIELD_MAX.org.description}
    />
  );
}
